import { canReviewAccessRequests } from '@infras/shared-types';
import { AdminGate } from '../components/AdminGate';
import { AccessReviewers } from '../components/AccessReviewers';
import { useMe } from '../lib/useMe';

/** Administration → Default access assignees (`/settings/reviewers`, alias
 *  `/settings/access-assignees`): who is assigned to a new access task when the
 *  requester picks nobody. A flat list — layered review was removed. */
export function AccessReviewersPage() {
  const { me } = useMe();
  return (
    <AdminGate allowed={!!me && canReviewAccessRequests(me.role)} need="root users and maintainers">
      <div className="page page--wide">
        <div className="detail-head">
          <h2>Default access assignees</h2>
        </div>
        <p className="detail-desc">
          Everyone on this list is assigned to every new access task. The requester can remove them or add anyone
          else. Any assignee, whatever their role, or a root user or maintainer can approve or deny it. Removing a
          person here does not unassign them from open tasks.
        </p>
        <AccessReviewers />
      </div>
    </AdminGate>
  );
}
